export default {
  onlineCo2Stats: []
};
